import { Component, OnInit, ViewChild } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TableData } from 'src/app/shared/models/tableData';
import { ToolInventoryTransferSearchComponent } from './search/tool-inventory-transfer-search.component';
import { alert, assignment, model } from './tool-inventory-transfer.functions';
import { ToolInventoryTransferService } from './tool-inventory-transfer.service';

@Component({
  selector: 'app-tool-inventory-transfer',
  templateUrl: './tool-inventory-transfer.component.html',
  styleUrls: ['./tool-inventory-transfer.component.scss'],
})
export class ToolInventoryTransferComponent implements OnInit {
  @ViewChild('transferSearch')
  private toolTransferSearch: ToolInventoryTransferSearchComponent;

  subscription: Subscription;

  tableData: TableData = {
    label: 'Tool',
    type: 'tools',
    selectable: false,
    statusToggle: false,
    noResultsMessage: 'No tools selected.',
    tableClasses: { fixed: true },
    columns: [
      {
        name: 'toolId',
        label: 'Tool ID',
        property: 'toolId',
        sortable: false,
        columnStyles: { 'max-width': '110px' },
        headerStyles: { 'min-width': '104px', 'width': '100px' },
        columnClasses: { 'text-truncate': true },
      },
      {
        name: 'tool_name',
        label: 'Tool Name',
        property: row => {
          return model(row, 'name');
        },
        sortable: false,
        columnStyles: { 'max-width': '210px' },
        columnClasses: { 'text-truncate': true },
      },
      {
        name: 'assignedTo',
        label: 'Assigned To',
        property: row => assignment(row, 'primaryAssignment'),
        sortable: false,
        columnStyles: { 'max-width': '110px' },
        headerStyles: { 'min-width': '210px' },
        columnClasses: { 'text-truncate': true },
      },
      {
        name: 'assignment',
        label: 'Status',
        property: row => assignment(row, 'type.name'),
        sortable: false,
        columnStyles: { 'max-width': '110px' },
        headerStyles: { 'min-width': '104px' },
        dataClasses: row => {
          const type = assignment(row, 'type.name');
          return `status ${type && type.toLowerCase().replace(/\s/g, '-')}`;
        },
      },
      {
        name: 'assignedTo',
        label: 'Alert Code',
        property: row => (alert(row, 'enabled') && alert(row, 'message') ? alert(row, 'message') : ''),
        popover: row => alert(row, 'enabled'),
        sortable: false,
        columnStyles: { 'max-width': '110px' },
        headerStyles: { 'min-width': '210px' },
        columnClasses: { 'text-truncate': false },
      },
    ],
    rowActions: [
      {
        label: 'Delete',
        iconName: 'far fa-times',
        show: x => true,
        click: (event, row) => {
          this.toolInventoryTransferService.remove(row.id);
          this.toolTransferSearch.deselectItem(row.id);
        },
      },
    ],
    data: [],
    pagination: {},
  };

  inventoryTransferModalIsOpen: boolean = false;

  constructor(
    private toolInventoryTransferService: ToolInventoryTransferService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.subscription = this.toolInventoryTransferService.inventoryTransferModalIsOpen.subscribe(value => (this.inventoryTransferModalIsOpen = value));

    this.subscription = this.toolInventoryTransferService.selectedInventoryItems.subscribe(data => (this.tableData.data = data));

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.toolInventoryTransferService.close();
      }
    });
  }

  handleClose() {
    this.toolInventoryTransferService.close();
  }

  handleClear() {
    this.toolInventoryTransferService.clear();
  }
}
